// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-device"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 8.58789H8.5H12V20.9997H3V8.58789Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 21V8.58824H8.5V3H21V21H12Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 21V8.58824H8.5V3H21V21H12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 17H8M3 8.58789V20.9997H12V8.58789H3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemDeviceIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-device',
    ref,
    icon: element,
  },
));

SystemDeviceIcon.displayName = 'SystemDeviceIcon';

export default SystemDeviceIcon;
